export default __webpack_public_path__ + "static/square_b.82e69bf1fffd995a6e97574031195e67.png";